// extracted by mini-css-extract-plugin
export default {"wrap":"Marquee_wrap__27FoD","track":"Marquee_track__xDAqG","marquee":"Marquee_marquee__LvNW3","item":"Marquee_item__CeNE7"};